var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c("div", { staticClass: "boss-main-wrap" }, [
      _c(
        "section",
        { staticClass: "boss-contractperiod-container" },
        [
          _c("scout-period-bar", {
            attrs: {
              "first-date": _vm.contract.firstDate,
              "last-date": _vm.contract.lastDate,
              "scout-limit": _vm.contract.scoutLimit,
              "sent-scout-amount": _vm.contract.sentScoutAmount,
              "reserved-scout-first-send-amount":
                _vm.contract.reservedScoutFirstSendAmount,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "boss-contractperiod-wrap" }, [
            _c("div", { staticClass: "boss-posting-container" }, [
              _c(
                "div",
                { staticClass: "boss-posting-wrap boss-main-content-wrap" },
                [
                  _c("scout-job-header", {
                    attrs: {
                      jobs: _vm.jobs,
                      "is-selectable": _vm.isSelectable,
                    },
                  }),
                  _vm._v(" "),
                  _c("scout-tab-menu", {
                    attrs: {
                      "job-id": Number(_vm.jobId),
                      "contract-id": Number(_vm.contractId),
                    },
                  }),
                  _vm._v(" "),
                  _c("router-view"),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }